<template>
    <AppLayout>
        <div class="bg-white">
            <!-- Page hero -->
            <div class="bg-[#17364a] py-16">
                <div class="mx-auto max-w-7xl px-6 lg:px-8">
                    <nav aria-label="Breadcrumb" class="mb-4">
                        <ol role="list" class="flex items-center space-x-2">
                            <li v-for="breadcrumb in page.breadcrumbs" :key="breadcrumb.id" class="flex items-center">
                                <a :href="breadcrumb.href" class="text-xs text-gray-400 hover:text-white">{{ breadcrumb.name }}</a>
                                <span class="mx-2 text-gray-600">/</span>
                            </li>
                            <li class="text-xs text-gray-300">{{ page.name }}</li>
                        </ol>
                    </nav>
                    <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830] mb-3 block">Legal</span>
                    <h1 class="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">{{ page.name }}</h1>
                </div>
            </div>

            <!-- Content -->
            <div class="mx-auto max-w-7xl px-6 lg:px-8 py-16">
                <div v-html="privacyPolicy ? privacyPolicy.content : '...'" class="prose prose-sm max-w-none text-gray-600"></div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import { ref } from 'vue';
import { getPrivacyPolicy } from '@/services/pageService';

const privacyPolicy = ref(null);

const fetchPrivacyPolicy = async () => {
    const response = await getPrivacyPolicy();
    privacyPolicy.value = response.data;
}

fetchPrivacyPolicy();

const page = {
    name: 'Privacy Policy',
    breadcrumbs: [
        { id: 1, name: 'Home', href: '/' },
    ],
}
</script>
